import { gql } from '@apollo/client';

const PATIENT_ONBOARDING_FRAGMENT = gql`
  fragment PatientOnBoardingFragment on PatientOnBoarding {
    patientSymptoms
    frequentlyOfSymptoms
    usedHeartMonitor
    pacer
    icd
  }
`;

export default PATIENT_ONBOARDING_FRAGMENT;
